import script from "./AbrirCajaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AbrirCajaModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__